import { Box, Card, Typography, Button, Tooltip } from '@mui/joy'
import { useSelectedModule } from 'api/users'
import { useAuth } from 'context/Auth'
import { useNavigate } from 'react-router-dom'
import AppsRoundedIcon from '@mui/icons-material/AppsRounded'
import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded'
import ScreenSearchDesktopRoundedIcon from '@mui/icons-material/ScreenSearchDesktopRounded'

type Props = {}
const NavModules = (props: Props) => {
    const auth = useAuth()
    const navigate = useNavigate()

    let access = auth?.user?.access

    const chatApiModule = auth.user?.access?.chatAPIs
    const webApiModule = auth.user?.access?.webAPIs
    const dataAppModule = auth.user?.access?.dataApps

    const selectedModule = auth.user?.selections?.selectedModule

    const dataAppAccessAllowed = access === null || dataAppModule === true

    const { mutate: changeModules, data } = useSelectedModule()

    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                justifyContent: 'space-between',
                marginBottom: '12px',
            }}
        >
            <Tooltip title="Chat APIs" placement="top" color="neutral">
                <div
                    style={{
                        position: 'relative',
                    }}
                >
                    <Button
                        onClick={() =>
                            changeModules(
                                {
                                    selectedModule: 'chatAPIs',
                                },
                                {
                                    onSuccess: () => {
                                        navigate('/integrations')
                                    },
                                }
                            )
                        }
                        sx={{
                            cursor: 'pointer',
                        }}
                        variant="soft"
                        disabled={!chatApiModule}
                    >
                        <QuestionAnswerRoundedIcon />
                    </Button>
                    {selectedModule === 'chatAPIs' && (
                        <div
                            style={{
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                backgroundColor: '#37AA0B',
                                position: 'absolute',
                                bottom: '-12px',
                                left: '50%',
                                marginLeft: '-3px',
                            }}
                        ></div>
                    )}
                </div>
            </Tooltip>
            <Tooltip title="Data Apps" placement="top" color="neutral">
                <div
                    style={{
                        position: 'relative',
                    }}
                >
                    <Button
                        onClick={() =>
                            changeModules(
                                {
                                    selectedModule: 'dataApps',
                                },
                                {
                                    onSuccess: () => {
                                        navigate('/apps')
                                    },
                                }
                            )
                        }
                        sx={{
                            cursor: 'pointer',
                        }}
                        variant="soft"
                        disabled={!dataAppAccessAllowed}
                    >
                        <AppsRoundedIcon />
                    </Button>
                    {selectedModule === 'dataApps' && (
                        <div
                            style={{
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                backgroundColor: '#37AA0B',
                                position: 'absolute',
                                bottom: '-10px',
                                left: '50%',
                                marginLeft: '-3px',
                            }}
                        ></div>
                    )}
                </div>
            </Tooltip>
            <Tooltip title="Web APIs" placement="top" color="neutral">
                <div>
                    <Button variant="soft" disabled={!webApiModule}>
                        <ScreenSearchDesktopRoundedIcon />
                    </Button>
                    {selectedModule === 'webAPIs' && (
                        <div
                            style={{
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                backgroundColor: '#37AA0B',
                                position: 'absolute',
                                bottom: '-10px',
                                left: '50%',
                                marginLeft: '-3px',
                            }}
                        ></div>
                    )}
                </div>
            </Tooltip>
        </Box>
    )
}
export default NavModules
